/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var BrowserDetect = {
      init: function () {
          this.browser = this.searchString(this.dataBrowser) || "Other";
          this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
      },
      searchString: function (data) {
          for (var i = 0; i < data.length; i++) {
              var dataString = data[i].string;
              this.versionSearchString = data[i].subString;

              if (dataString.indexOf(data[i].subString) !== -1) {
                  return data[i].identity;
              }
          }
      },
      searchVersion: function (dataString) {
          var index = dataString.indexOf(this.versionSearchString);
          if (index === -1) {
              return;
          }

          var rv = dataString.indexOf("rv:");
          if (this.versionSearchString === "Trident" && rv !== -1) {
              return parseFloat(dataString.substring(rv + 3));
          } else {
              return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
          }
      },

      dataBrowser: [
          {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"},
          {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
          {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
          {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
          {string: navigator.userAgent, subString: "Safari", identity: "Safari"},
          {string: navigator.userAgent, subString: "Opera", identity: "Opera"}
      ]

  };

BrowserDetect.init();

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}

Modernizr.addTest('svgasimg', document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1'));

function calculateOverflow() {
  var window_height = $(window).height();
  var content_height = $('.content__inner').height();


  if (!$('body').hasClass('overflow')) {
    if (window_height < content_height) {
      $('body').addClass('overflow');
    }
  }
  if ($('body').hasClass('overflow')) {
    if (window_height >= content_height) {
      $('body').removeClass('overflow');
    }
  }
}

// Do things

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        svg4everybody();

        window.submittedForm = null;

        if(!Modernizr.touchevents){
          $("a[href*='tel:']").on('click',function(){
            return false;
          });
        }
        $("[data-block]").on('click',function(){
          var $el = $($(this).data('block'));
          $("html").velocity("scroll", { offset: $el.offset().top, mobileHA: false });
          return false;
        });
        $("a.video").magnificPopup({
          type:'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 300,
           callbacks:{
            open:function(){
              var pInstance = $(".hero.front").data('vide');
              if(pInstance){
                pInstance = pInstance.getVideoObject();
                pInstance.pause();
              }
            },
            close:function(){
              var pInstance = $(".hero.front").data('vide');
              if(pInstance){
                pInstance = pInstance.getVideoObject();
                pInstance.play();
              }
            }
          },
          iframe: {
            markup: '<div class="mfp-iframe-scaler">'+
                      '<div class="mfp-close"></div>'+
                      '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                    '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

            patterns: {
              youtube: {
                index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                id: 'v=', // String that splits URL in a two parts, second part should be %id%
                // Or null - full URL will be returned
                // Or a function that should return %id%, for example:
                // id: function(url) { return 'parsed id'; }

                src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: '//player.vimeo.com/video/%id%?autoplay=1'
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed'
              }
            }
          }
        });

      },
      finalize: function() {
        objectFitImages();
        $("nav.greedy").makeGreedy();
        $(".matchHeight,.equalHeight").matchHeight();

        var diLoader = new Loader('.loader--form-di', {
          triggerData: 'form-di'
        });

        var htLoader = new Loader('.loader--form-ht', {
          triggerData: 'form-ht'
        });

        // We probably don't need this right away
        var swiper = new Swiper ('.slider .swiper-container', {
          pagination: '.swiper-pagination',
          direction: 'horizontal',
          loop: true,
          slidesPerView: 4,
          paginationClickable: true,
          spaceBetween: 0,
          breakpoints: {
              1024: {
                  slidesPerView: 4,
                  spaceBetween: 0
              },
              768: {
                  slidesPerView: 3,
                  spaceBetween: 0
              },
              640: {
                  slidesPerView: 2,
                  spaceBetween: 0
              },
              320: {
                  slidesPerView: 1,
                  spaceBetween: 0
              }
          }
        });

        calculateOverflow();
        // @TODO: Debounce
        $(window).on('resize', function() {
          calculateOverflow();
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

            // var hero = $('.hero').vide('{URL GOES HERE}', {
            //   volume: 0,
            //   playbackRate: 1,
            //   muted: true,
            //   loop: true,
            //   autoplay: true,
            //   position: '50% 50%', // Similar to the CSS `background-position` property.
            //   posterType: 'none', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
            //   resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
            //   bgColor: 'black', // Allow custom background-color for Vide div,
            //   className: 'video' // Add custom CSS class to Vide div
            // });
            // var resizeVideo = function(){
            //   hero.resize();
            // };
            // requestAnimationFrame(resizeVideo);

      },
      finalize: function() {

      }
    },
    // About us page, note the change from about-us to about_us.
    'not_front': {
      init: function() {
        // JavaScript to be fired on the about us page
        $('a.gallery').magnificPopup({
          type: 'image',
          mainClass: 'mfp-fade',
          removalDelay: 300,
          gallery:{
            enabled:true
          },
          image: {
            markup: '<div class="mfp-figure">'+
                      '<div class="mfp-close"></div>'+
                      '<div class="mfp-img"></div>'+
                      '<div class="mfp-bottom-bar">'+
                        '<div class="mfp-title"></div>'+
                        '<div class="mfp-counter"></div>'+
                      '</div>'+
                    '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button

            cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.

            //titleSrc: 'title', // Attribute of the target element that contains caption for the slide.
            // Or the function that should return the title. For example:
            titleSrc: function(item) {
              //console.log($(item.el).find('img').attr('title'));
              return $(item.el).find('img').attr('title');
            },

            verticalFit: true, // Fits image in area vertically

            tError: '<a href="%url%">The image</a> could not be loaded.' // Error message
          },
          callbacks: {
            open: function() {
              $.magnificPopup.instance.next = function() {
                var self = this;
                self.wrap.removeClass('mfp-image-loaded');
                self.wrap.addClass('next');
                setTimeout(function() {
                  $.magnificPopup.proto.next.call(self);
                }, 400);
              };
              $.magnificPopup.instance.prev = function() {
                var self = this;
                self.wrap.removeClass('mfp-image-loaded');
                self.wrap.addClass('prev');
                setTimeout(function() {
                  $.magnificPopup.proto.prev.call(self);
                }, 400);
              };
            },
            imageLoadComplete: function() {
              var self = this;
              self.wrap.addClass('mfp-image-loading');
              setTimeout(function() {
                self.wrap.removeClass('mfp-image-loading prev next');
                self.wrap.addClass('mfp-image-loaded');
              }, 10);
            }
          }
        });

      }
    },
    'our_team': {
      init: function() {

      },
       finalize: function() {

       }
    },
    'contact': {
      init: function() {

      },
       finalize: function() {
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');
        // Fire page-specific init JS, and then finalize JS
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
          UTIL.fire(classnm);
          setTimeout(function(){
            UTIL.fire(classnm, 'finalize');
          },200);
        });
        // Fire common finalize JS
        setTimeout(function(){
          UTIL.fire('common', 'finalize');
          console.info( "main.js file has fired all commands." );
        },200);

    }
  };

  // var stylesheet = loadCSS( cssFile, document.getElementById("css-ref") );
  // onloadCSS( stylesheet, function() {
  //   console.info( "Stylesheet has loaded." );
  //   $(document).ready(UTIL.loadEvents);
  // });
  $(document).ready(UTIL.loadEvents);
  // function repeatOften() {
  //   // Do whatever

  //   var height = $("#loaded").css('height');
  //   console.log(height);
  //   if(height !== 0){
  //     //cancelAnimationFrame(repeatOften);
  //   }
  //   window.requestAnimationFrame(repeatOften);
  // }
  // window.requestAnimationFrame(repeatOften);

  var $form = $('.form');

  $form.each(function() {
    $(this).validate({
      rules: {
        di_first_name: "required",
        di_last_name: "required",
        di_email: {
          required: true,
          email: true
        },
        ht_first_name: "required",
        ht_last_name: "required",
        ht_email: {
          required: true,
          email: true
        }
      },
      messages: {
        di_first_name: "Required",
        di_last_name: "Required",
        di_email: {
          required: "Required",
          email: "Invalid Email Address"
        },
        ht_first_name: "Required",
        ht_last_name: "Required",
        ht_email: {
          required: "Required",
          email: "Invalid Email Address"
        }
      },
      submitHandler: function(form, event) {
        event.preventDefault();
        window.submittedForm = "#" + $(form).attr('id');
        var captchaResponse = grecaptcha.getResponse();

        if (captchaResponse) {
          var classes = $(form).attr('class').split(' ');
          var fid;
          for (var i = 0; i < classes.length; i++) {
            if (classes[i] !== 'form' && classes[i].includes('form--')) {
              fid = classes[i].replace('form--', '');
              break;
            }
          }

          $(form).find('input[type=submit]').attr('disabled');

          var first_name   = $('input[name="' + fid + '_first_name"]').val();
          var last_name    = $('input[name="' + fid + '_last_name"]').val();
          var phone        = $('input[name="' + fid + '_phone"]').val();
          var email        = $('input[name="' + fid + '_email"]').val();
          var message      = $('textarea[name="' + fid + '_message"]').val();
          var services     = [];
          var form_id      = $('input[name="' + fid + '_form_id"]').val();

          $('input[name="' + fid + '_services[]"]:checked').each(function() {
            services.push($(this).val());
          });

          grecaptcha.reset();

          var call = $.ajax({
              url: "./mail/contact.php",
              type: "POST",
              dataType: 'json',
              data: {
                first_name: first_name,
                last_name: last_name,
                email: email,
                phone: phone,
                services: services,
                form_id: form_id,
                message: message
              },
              cache: false,
          });

          call.done(function(data) {
            if (data.success === 1) {
              console.log('form submitted');
              var $loader = $('form[data-id="' + data.id + '"]').parents('.loader');

              $loader.addClass('is-submitted');
              $loader.children('.loader__content').fadeOut(400, function() {
                $loader.children('.loader__success').fadeIn();
              });
              // $('form').trigger("reset");
            } else {
              alert("Form submission failed.");
              // $('form').trigger("reset");
            }
          });

          call.fail(function(data) {
            alert("Form submission failed.");
          });
        } else {
          console.log('no response');
          grecaptcha.reset();
          grecaptcha.execute();
        }
      }
    });
  });

  function captchaSubmit(token) {
    if (window.submittedForm) {
      console.log('submitting' + window.submittedForm);
      $(window.submittedForm).submit();
    } else {
      alert("reCaptcha failed");
    }
  }
  window.captchaSubmit = captchaSubmit;

})(jQuery); // Fully reference jQuery after this point.